export default __webpack_public_path__ + "static/media/rocket.daeffb47.png";